import { render, staticRenderFns } from "./ClientsCrudClientNotices.vue?vue&type=template&id=95a71fea&"
import script from "./ClientsCrudClientNotices.vue?vue&type=script&lang=js&"
export * from "./ClientsCrudClientNotices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports